<div class="blade-wrapper">
  <div class="blade-header">
    <div  class="blade-tools">
    </div>
    <ng-content></ng-content>
  </div>
  <div class="blade-content">
    <div class="datex-form">
      <ng-container *ngIf="initialized ">
        <div [formGroup]="formGroup"
             class="formdata">
                <div data-cy="fieldset-id-pallet_activator"
                     *ngIf="!fieldsets.pallet_activator.hidden && !fieldsets.pallet_activator.removed"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': fieldsets.pallet_activator.collapsible }">
                    <div *ngIf="!fieldsets.pallet_activator.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="fieldsets.pallet_activator.toggle()">
                      <span class="fieldsetsTitle-text">
                      {{fieldsets.pallet_activator.label}}
                      </span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="fieldsets.pallet_activator.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !fieldsets.pallet_activator.expanded, 'icon-ic_fluent_chevron_up_20_filled': fieldsets.pallet_activator.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="fieldsets.pallet_activator.expanded"
                         class="fieldsetsGroup">
                      <div data-cy="field-id-shipping_container" *ngIf="!fields.shipping_container.hidden && !fields.shipping_container.removed" 
                            class="field-container double {{fields.shipping_container.invalid ? 'invalid' : ''}} {{fields.shipping_container.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.shipping_container.styles.style"
                            [ngClass]="fields.shipping_container.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.shipping_container.tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.shipping_container.label}}<span *ngIf="fields.shipping_container.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="textBox" formControlName="shipping_container"
                                matInput
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-textbox {{ (fields.shipping_container.control.readOnly || fields.shipping_container.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.shipping_container.control.placeholder}}"
                                [ngStyle]="fields.shipping_container.control.styles.style"
                                [ngClass]="fields.shipping_container.control.styles.classes"
                                [matTooltip]="fields.shipping_container.control.tooltip"> 
                        <ng-container *ngIf="fields.shipping_container.invalid">
                          <ng-container *ngFor="let error of fields.shipping_container.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-message" *ngIf="!fields.message.hidden && !fields.message.removed" 
                            class="field-container double {{fields.message.invalid ? 'invalid' : ''}} {{fields.message.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.message.styles.style"
                            [ngClass]="fields.message.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.message.tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.message.label}}<span *ngIf="fields.message.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <textarea cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="5" data-cy="textBox-multi" formControlName="message"
                                matInput
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-textbox {{ (fields.message.control.readOnly || fields.message.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.message.control.placeholder}}"
                                [ngStyle]="fields.message.control.styles.style"
                                [ngClass]="fields.message.control.styles.classes"
                                [matTooltip]="fields.message.control.tooltip"> </textarea>
                        <ng-container *ngIf="fields.message.invalid">
                          <ng-container *ngFor="let error of fields.message.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>            </div>
        
                    <div class="fieldset-details" *ngIf="!fieldsets.pallet_activator.expanded">
        
        
                    </div>
                  </div>
                </div>
              </div>
      </ng-container>

    </div>
  </div>
</div>